import { LazyLoadable } from '@mews-commander/ui';
import { RestrictionFormContainerProps } from './types';

interface Exports {
    RestrictionsModule: typeof import('../../index');
}

export const RestrictionFormContainer = LazyLoadable<RestrictionFormContainerProps, Exports, {}>({
    loader: {
        RestrictionsModule: async () => import(/* webpackChunkName: "Restrictions" */ '../../index'),
    },
    render(loaded, { serviceId, injectReducer, dispatch, getState, ...other }) {
        const {
            RestrictionsModule: {
                RestrictionFormContainer: LoadedRestrictions,
                restrictionsReducer,
                restrictionsModuleName,
            },
        } = loaded;
        injectReducer(restrictionsModuleName, restrictionsReducer);

        return <LoadedRestrictions serviceId={serviceId} {...other} />;
    },
});
